import React, { useState, useEffect, useRef, useCallback } from "react";
import { message, Tabs } from "antd";
const { TabPane } = Tabs;
import locale from "../../_util/locale";
// import IconFont from "../../_util/Iconfont";

import isEqual from "lodash/isEqual";
import SvgIcon from "../../assets/icons";
import { PageTabInfo } from "./utils";

// import "./index.less";
// import moment from "moment";
// import "moment/locale/zh-cn";
// moment.locale("zh-cn");

import { IItemData } from "./common.typing";
import Home from "./Home";
import Organization from "./Organization";
import RecentSession from "./RecentSession";
import MyGroup from "./MyGroup";
import GroupMember from "./GroupMember";
import Main from "./Main";

import CommonlyContactPage from "./commonlyContactPage";
import MyPartner from "./MyPartner";
import PartnerMember from "./PartnerMember";
import ExternalContact from "./ExternalContact";
import BatchImport from "./BatchImport";
import SearchPage from "./searchPage/SearchPage";

import UserPicker from "./picker/UserPicker";
import OrgPicker from "./picker/OrgPicker";
import GroupPicker from "./picker/GroupPicker";
import SessionPicker from "./picker/SessionPicker";

import SearchHeader from "./searchPage/searchHeader";
export interface ComplexPickerProps {
    /** 组件类型：
     * - 选人：member
     * - 选群：group
     * - 选会话：session
     * - 选组织架构：org
     * - 选我的伙伴：partner
     * - default：member
     */
    type?: string;
    /**
     * 右侧页面
     * - 首页：home
     * - 我的群组：myGroup
     * - 群成员：groupMember
     * - 最近会话：recentSession
     * - 组织架构：organization
     * - 我的伙伴：myPartner
     * - 我的伙伴成员：partnerMember
     * - 外部联系人：externalContact
     * - default：home
     */
    page?: string;
    /** 组件的标题 */
    title?: string;
    /** 关闭组件方法 */
    onClose: () => void;
    /** 是否展示【我的群组】入口，default：false */
    showGroups?: boolean;
    /** 是否展示【最近会话】入口，default：false */
    showRecentSession?: boolean;
    /** 是否展示【组织架构】入口，默认为 true */
    showOrganization?: boolean;
    /** 是否展示 【我的伙伴】入口，默认为 true */
    showPartner?: boolean;
    /** 是否展示【外部联系人】入口，默认为 false */
    showExternalContact?: boolean;
    /** 是否有权限按照组织架构选人，default：all */
    authority?: string;
    /** 是否为单一选择组织架构信息 */
    /** 获取当前用户的组织架构信息，用于 home 页 */
    getPersonOrg?: () => void;
    /** 根据部门 id 获取组织架构信息 */
    getOrgList?: (obj?: IItemData, from?: string) => void;
    /** 组织架构展开信息 */
    orgList?: IItemData[];
    /** 组织架构下的成员 */
    orgUser?: IItemData[];
    /** 组织架构面包屑 */
    orgBread?: IItemData[];
    /** 个人的组织架构信息 */
    personOrg?: IItemData;
    /** 常用联系人（扁平列表） */
    commonlyList?: IItemData[];
    /** 常用联系人（A-Z 分组数据） */
    commonlyGrouped?: { [letter: string]: IItemData[] };
    /** 最近联系人 */
    recentConcactsList?: IItemData[];
    /** 获取最近会话列表 */
    getRecentSessionList?: () => void;
    /** 最近会话列表 */
    recentSessionList?: IItemData[];
    /** 最近转发列表 */
    recentForwardList?: IItemData[];
    /** 获取我的群组列表 */
    getMyGroupList?: () => void;
    /** 我的群组列表 */
    myGroupList?: IItemData[];
    /** 根据群 id 获取群成员 */
    getGroupMemberList?: (id: number | string) => void;
    /** 获取我的伙伴列表 */
    getPartnerList?: () => Promise<any>;
    /** 根据群 id 获取我的伙伴成员 */
    getPartnerMemberList?: (
        id: number | string,
        show_external: number
    ) => Promise<any>;
    /** 根据群 id 获取我的伙伴成员（A-Z 分组数据） */
    getPartnerMemberGrouped?:(
        id: number | string,
        show_external: number
    ) => Promise<any>;
    // 获取外部联系人列表
    getContactList?: (last_id: number, pageSize: number) => Promise<any>;
    /** 群成员列表（扁平列表） */
    groupMemberList?: IItemData[];
    /** 群成员列表（A-Z 分组数据） */
    groupMemberGrouped?: { [letter: string]: IItemData[] };
    /** 群成员列表的群 id */
    groupId?: number | string;
    /** 群成员列表的群名称 */
    groupName?: string;
    /** 不可用 id，包括 group、user、session、org */
    disabledids?: string[];
    /** 已选择的，包括 group、user、session、org */
    pickedList?: IItemData[];
    /** 必须选择的，包括 group、user、session、org */
    requiredList?: IItemData[];
    /** 可选的最大数量，默认为 1 */
    maxNum?: number;
    /**
     * 是否为多选
     * SessionPicker 默认为 false
     * 其他默认为 true
     */
    multiple?: boolean;
    /** 数量超出时的提示，默认为【选择数量超限】 */
    limitTips?: string;
    /** 左侧搜索的 placeholder */
    searchPlaceholder?: string;
    /**
     * 左侧搜索事件
     * key： 关键词
     * rows：加载条数
     */
    loadSearchData?: (
        key: string,
        rows?: number
    ) => Promise<
        {
            title: string;
        }[]
    >;
    /**
     * 加载更多搜索结果
     * type：类型 - user、group
     * key：关键词
     * row：加载条数，默认 20，暂不支持自定义
     */
    loadSearchDataMore?: (
        type: string,
        key: string,
        rows: number
    ) => Promise<any>;
    /**
     * 搜索类型
     * 选择会话组件：['user', 'group']
     * 选人组件：['user']
     * 选群组件：['group']
     * 不传为不支持搜索，选择组织架构组件不支持搜索
     */
    searchType?: string[];
    /** 搜索结果数据 */
    searchData?: IItemData[];
    /** 加载 searchData 中 */
    isLoadingSearchData?: boolean;
    /** 点击确定 */
    onConfirm: (data: string[], length: number) => void;
    /**
     * 是否展示确认按钮的数量
     * default：true
     */
    showSelectedNum?: boolean;
    /**
     * 确认按钮是否为 loading 态
     * default：false
     */
    isConfirmLoading?: boolean;
    /**
     * 搜索面板消失触发函数
     */
    selectPanelBlur?: () => void;

    calcDeptMembers?: boolean;

    /** 是否展示批量导入 */
    showBatchImport?: boolean;
    /** 批量导入接口 */
    batchImportApi?: (workCodes: string[]) => Promise<any>;

    /** 可选总数为 0 时确认按钮可点击，默认为 false */
    canSelectZero?: boolean;
    /** 搜索预留内容区域 */
    mainChildren?: React.ReactNode;
    /** 隐藏群组成员页面标题 */
    isHideGroupMemberPageTitle?: boolean;
    /** 是否展示群组成员角色 */
    isShowGroupMemberRole?: boolean;
    /** 是否展示群组成员全选 */
    showGroupMemberCheckAll?: boolean;
    /** 是否只展示选中的数量,不显示最大数量 */
    justShowSelectedNoMax?: boolean;
    /** 是否从组织架构开始选人，如超管 */
    orginSelect?: boolean;
    /** 是否禁用标题拖拽 */
    isDisableTitleDrag?: boolean;
    /** 是否展示最近转发 */
    showRecentForward?: boolean;
    /** 是否展示最近联系人 */
    isShowRecentConcacts?: boolean;
    /** 埋点方法 */
    track?: (eventName: string, eventData?: any) => void;
}

export interface ComplexPickerInterface extends React.FC<ComplexPickerProps> {
    UserPicker: typeof UserPicker;
    OrgPicker: typeof OrgPicker;
    GroupPicker: typeof GroupPicker;
    SessionPicker: typeof SessionPicker;
}

const ComplexPicker: ComplexPickerInterface = ({
    page,
    type,
    title,
    onClose,
    showGroups,
    showRecentSession,
    showOrganization,
    showPartner = false,
    showExternalContact = false,
    authority,
    getPersonOrg,
    getOrgList,
    orgList,
    orgUser,
    orgBread,
    personOrg,
    commonlyList,
    commonlyGrouped,
    recentConcactsList,
    getRecentSessionList,
    recentSessionList,
    recentForwardList,
    getMyGroupList,
    myGroupList = [],
    getGroupMemberList,
    groupMemberList = [],
    groupMemberGrouped,
    groupId = 0,
    groupName = "",
    disabledids,
    pickedList = [],
    requiredList = [],
    maxNum,
    multiple,
    limitTips,
    searchPlaceholder,
    loadSearchData,
    loadSearchDataMore,
    searchType,
    searchData,
    isLoadingSearchData,
    onConfirm,
    showSelectedNum,
    isConfirmLoading,
    getPartnerMemberList,
    getPartnerMemberGrouped,
    getPartnerList,
    getContactList,
    selectPanelBlur,
    calcDeptMembers,

    showBatchImport,
    batchImportApi,

    canSelectZero = false,
    mainChildren = null,
    isHideGroupMemberPageTitle,
    isShowGroupMemberRole,
    showGroupMemberCheckAll = true,
    justShowSelectedNoMax = false,
    orginSelect = false,
    isDisableTitleDrag,
    showRecentForward = false,
    isShowRecentConcacts = false,
    track = () => {},
}) => {
    const [byContactTabList, setByContactTabList] = useState<any[]>([]); // 按联系人的tab列表（包含我的伙伴、外部联系人）
    const [bySessionTabList, setBySessionTabList] = useState<any[]>([]); // 按会话的tab列表 （包含最近会话、我的群组）
    const [pageTabList, setPageTabList] = useState<any[]>([]); // 公用页面tab列表
    const [defaultPageTabKey, setDefaultPageTabKey] = useState(page); // 设置默认页面tab
    const [activePageTabKey, setActivePageTabKey] = useState(page); // 设置当前激活的tab
    const [currentPage, setCurrentPage] = useState(page);
    const [isSearchMode, setIsSearchMode] = useState(false); // 是否为搜索模式,否则为正常模式
    const [prePage, setPrePage] = useState("");
    const [currentGroupInfo, setCurrentGroupInfo] = useState({
        id: groupId,
        name: groupName,
    });
    const [maxNumber, setMaxNumber] = useState(maxNum);
    const [currentList, setCurrentList] = useState<IItemData[]>([]);
    const [isShowOrganization, setIsShowOrganization] = useState(false);
    const [totalCount, setTotalCount] = useState(0);

    const [currentPartnerInfo, setCurrentPartnerInfo] = useState({
        id: groupId,
        name: groupName,
    });

    const _requiredList = usePreviousValue(requiredList) || [];
    const _pickedList = usePreviousValue(pickedList) || [];
    const _currentList = usePreviousValue(currentList) || [];

    const [searchKey, setSearchKey] = useState(""); // 搜索关键词
    const searchPageRef = useRef<any>(null);

    useEffect(() => {
        initPageConfig();
    }, []);

    useEffect(() => {
        setCurrentList([..._pickedList, ..._requiredList]);
    }, [_requiredList, _pickedList]);

    useEffect(() => {
        checkCurrentList();
    }, [_currentList]);

    useEffect(() => {
        setMaxNumber(!multiple ? 1 : maxNum);
    }, [maxNum]);

    /**
     * 比较并更新 ref 的值，用于避免不必要的重新渲染
     * @param value 要比较的值
     * @returns 如果值发生变化则返回新值，否则返回旧值
     */
    function usePreviousValue<T>(value: T): T | null {
        const ref = useRef<T | null>(null);
        if (!isEqual(value, ref.current)) {
            ref.current = value;
        }
        return ref.current;
    }

    const setTabInfo = useCallback((
        page: string,
        _byContactTabList = byContactTabList,
        _bySessionTabList = bySessionTabList
    ) => {
        console.log("setTabInfo--page", page);
        if (
            page === "commonlyContact" ||
            page === "myPartner" ||
            page === "externalContact"
        ) {
            // 常用联系人、我的伙伴、外部联系人
            setPageTabList(_byContactTabList);
            setActivePageTabKey(page);
        } else if (page === "recentSession" || page === "myGroup") {
            // 最近会话、我的群组
            setPageTabList(_bySessionTabList);
            setActivePageTabKey(page);
        } else {
            setPageTabList([]);
            setActivePageTabKey("");
        }
    }, [byContactTabList, bySessionTabList]);

    /**
     * 切换右侧页面
     * @param page 页面 id
     * - 首页：home
     * - 我的群组：myGroup
     * - 群成员：groupMember
     * - 最近会话：recentSession
     * - 组织架构：organization
     * - 常用联系人：commonlyContact
     * - 我的伙伴：myPartner
     * - 外部联系人：externalContact
     */
    const onChangeCurPage = useCallback((page: string) => {
        setCurrentPage(page);
        setTabInfo(page);
    }, [setTabInfo]);

    // Tab键切换Tabs功能
    useEffect(() => {
        // 如果 tab 列表为空或只有一个，不需要监听 Tab 键
        if (pageTabList.length <= 1) {
            return;
        }

        const handleTabKey = (event: KeyboardEvent) => {
            if (event.key === 'Tab') {
                event.preventDefault();
                const currentIndex = pageTabList.findIndex(tab => tab.key === activePageTabKey);
                const startIndex = currentIndex >= 0 ? currentIndex : 0;
                let nextIndex = startIndex < pageTabList.length - 1 ? startIndex + 1 : 0; // Tab键切换到下一个tab
                const nextTab = pageTabList[nextIndex];
                if (nextTab) {
                    onChangeCurPage(nextTab.key);
                }
            }
        };

        document.addEventListener('keydown', handleTabKey);
        // 确保清理函数正确移除事件监听器
        return () => {
            document.removeEventListener('keydown', handleTabKey);
        };
    }, [pageTabList, activePageTabKey, onChangeCurPage]);

    /**
     * 设置页面初始配置
     */
    const initPageConfig = () => {
        if (type === "group") {
            // 判断是否展示 组织架构
            setIsShowOrganization(false);
        } else if (type === "member") {
            // 判断是否展示 组织架构
            setIsShowOrganization(!!showOrganization);
            // 设置当前页面
            if (!!groupId) {
                setCurrentPage("groupMember");
                setPrePage("myGroup");
            } else if (orginSelect) {
                setCurrentPage("organization");
                setPrePage("home");
            }
        } else if (type === "org") {
            // 判断是否展示 组织架构
            setIsShowOrganization(true);
        } else if (type === "session") {
            // 判断是否展示 组织架构
            setIsShowOrganization(!!showOrganization);
        }

        // 如果为单选设置最大数量为 1
        !multiple && setMaxNumber(1);

        // 初始化需要展示的按联系人的tab列表
        let _byContactTabList: any[] = [];
        if (type !== "group" && type !== "org") {
            // 选群和选组织架构不展示常用联系人
            _byContactTabList.push(PageTabInfo.commonlyContact);
        }
        showPartner && _byContactTabList.push(PageTabInfo.myPartner); // 是否展示我的伙伴
        showExternalContact &&
            _byContactTabList.push(PageTabInfo.externalContact); // 是否展示外部联系人
        setByContactTabList(_byContactTabList);
        // 初始化需要展示的按会话的tab列表
        let _bySessionTabList: any[] = [];
        showRecentSession && _bySessionTabList.push(PageTabInfo.recentSession); // 是否展示最近会话
        showGroups && _bySessionTabList.push(PageTabInfo.myGroup); // 是否展示我的群组
        setBySessionTabList(_bySessionTabList);
        // 设置页面tab列表，并设置需要激活的tab
        if (page) {
            setTabInfo(page, _byContactTabList, _bySessionTabList);
        }
    };

    const onChangePrePage = (prePage: string) => {
        setPrePage(prePage);
    };

    /**
     * 计算人数
     */
    const getLength = (newList?: IItemData[]) => {
        let length = 0;
        (newList || currentList).forEach(v => {
            const id = v.id ? v.id.toString() : "";
            if (id.includes("-org-")) {
                if (type === "org") {
                    length += 1;
                } else if (type === "member") {
                    const num = +id.split("-org-")[1] || 1; // 兼容部门无法获取成员数量情况
                    length += num;
                } else if (type === "session") {
                    if (calcDeptMembers) {
                        const num = +id.split("-org-")[1] || 1; // 兼容部门无法获取成员数量情况
                        length += num;
                    } else {
                        length += 1;
                    }
                }
            } else if (id.includes("-user-")) {
                length += 1;
            } else if (id.includes("-team-")) {
                const num = +id.split("-team-")[1] || 1;
                length += num;
            } else if (id.includes("-level-")) {
                length += 1;
            } else if (id.includes("-partner-")) {
                let count = id.split("-partner-")[1];
                const num = count === "0" ? 0 : +count || 1; // 兼容部门无法获取成员数量情况
                length += num;
            } else {
                length += 1;
            }
        });
        setTotalCount(length);
        return length;
    };

    /**
     * 检查是否超出最大数量 maxNum 限制
     */
    const checkOutLength = (newList?: IItemData[]) => {
        if (!maxNumber) return false;
        return getLength(newList) > maxNumber;
    };

    /**
     * 监测 currentList 的变化
     */
    const checkCurrentList = () => {
        if (!multiple) {
            const newList = [...currentList.slice(-1)];
            setCurrentList && setCurrentList(newList);
            if (checkOutLength(newList)) {
                message.error({
                    content: limitTips,
                    key: limitTips,
                });
            }
        }

        if (multiple && checkOutLength())
            message.error({
                content: limitTips,
                key: limitTips,
            });
    };

    const handleClose = useCallback(() => {
        onClose();
        // 清空已选列表
        // setCurrentList([...pickedList, ...requiredList]);
        // setCurrentList([]);
    }, [onClose]);

    // ESC键关闭功能 - 只在非搜索模式下生效
    useEffect(() => {
        const handleEscapeKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && !isSearchMode) {
                event.preventDefault();
                handleClose();
            }
        };

        // 添加全局键盘事件监听
        document.addEventListener('keydown', handleEscapeKey);

        // 清理函数
        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [isSearchMode, handleClose]); // 依赖isSearchMode状态变化和handleClose函数

    // 自定义tab头部
    const renderTabBar: any = (props, DefaultTabBar) => (
        <div className="customTabBar">
            <SvgIcon
                component="ArrowLeft"
                className="iconBack"
                onClick={() => {
                    // setCurrentPage("home");
                    onChangeCurPage("home");
                }}
            />
            <DefaultTabBar {...props} className="site-custom-tab-bar" />
        </div>
    );

    // 进入搜索模式
    const gotoSearchPage = () => {
        setIsSearchMode(true);
    };

    // 退出搜索时，如果是群成员列表，做一次归位，防止搜索时的群成员页面修改了groupMemberList
    useEffect(() => {
        if (!isSearchMode && currentPage === "groupMember") {
            getGroupMemberList && getGroupMemberList(currentGroupInfo.id);
        }
    }, [isSearchMode]);

    return (
        <div className="complexPickerWrap" id="ComplexPicker" tabIndex={0}>
            <div
                className={`complexPickerTitle ${
                    isDisableTitleDrag ? "disableDrag" : ""
                }`}
            >
                <span>{title}</span>
                {/* <IconFont
                    type="icon-close"
                    className="complexPickerClose"
                    onClick={handleClose}
                /> */}
                <SvgIcon
                    component="Close"
                    onClick={handleClose}
                    className="complexPickerClose"
                />
            </div>
            <div className="complexPickerbox" tabIndex={-1}>
                <div className={`pages`}>
                    {searchType && searchType.length > 0 && (
                        <SearchHeader
                            searchPlaceholder={searchPlaceholder}
                            searchKey={searchKey}
                            setSearchKey={setSearchKey}
                            isSearchMode={isSearchMode}
                            handleClose={searchPageRef.current?.handleClose}
                            onChange={event => {
                                if (!isSearchMode) {
                                    gotoSearchPage();
                                }
                                searchPageRef.current &&
                                    searchPageRef.current.onChange(event);
                            }}
                            clearKeyword={searchPageRef.current?.clearKeyword}
                        />
                    )}

                    {/* 搜索模式 */}
                    {
                        <SearchPage
                            ref={searchPageRef}
                            isSearchMode={isSearchMode}
                            {...{
                                setSearchMode: setIsSearchMode,
                                searchType,
                                loadSearchDataMore,
                                loadSearchData,
                                currentList,
                                setCurrentList,
                                disabledids,
                                requiredList,
                                multiple,
                                searchPlaceholder,
                                searchKey,
                                setSearchKey,
                                track,
                                title,
                                type,
                                setCurrentGroupInfo,
                                getGroupMemberList,
                                groupMemberList,
                                groupMemberGrouped,
                                isHideGroupMemberPageTitle,
                                isShowGroupMemberRole,
                                showGroupMemberCheckAll,
                            }}
                        />
                    }
                    {/* 非搜索模式 */}
                    <div
                        className={`pagesContent ${isSearchMode ? "hide" : ""}`}
                    >
                        {currentPage === "home" && (
                            <Home
                                {...{
                                    type,
                                    showGroups,
                                    showRecentSession,
                                    showOrganization: isShowOrganization,
                                    showPartner,
                                    onChangeCurPage,
                                    currentList,
                                    setCurrentList,
                                    authority,
                                    getPersonOrg,
                                    getOrgList,
                                    personOrg,
                                    recentConcactsList,
                                    disabledids,
                                    requiredList,
                                    showExternalContact,
                                    showBatchImport,
                                    orginSelect,
                                    setPageTabList,
                                    byContactTabList,
                                    bySessionTabList,
                                    recentForwardList,
                                    showRecentForward,
                                    track,
                                    title,
                                    isShowRecentConcacts,
                                }}
                            />
                        )}
                        {pageTabList.length > 0 && (
                            <div className="tabsBox">
                                <Tabs
                                    animated
                                    defaultActiveKey={defaultPageTabKey}
                                    activeKey={activePageTabKey}
                                    onTabClick={tabKey =>
                                        onChangeCurPage(tabKey)
                                    }
                                    renderTabBar={renderTabBar}
                                >
                                    {pageTabList.map(tab => (
                                        <TabPane
                                            tab={tab.tab_name}
                                            key={tab.key}
                                        >
                                            {tab.key === "commonlyContact" && (
                                                <CommonlyContactPage
                                                    {...{
                                                        type: "member",
                                                        commonlyList,
                                                        commonlyGrouped,
                                                        disabledids,
                                                        requiredList,
                                                        currentList,
                                                        setCurrentList,
                                                        multiple,
                                                        track,
                                                        trackTitle: title,
                                                    }}
                                                />
                                            )}
                                            {tab.key === "myPartner" && (
                                                <MyPartner
                                                    {...{
                                                        type,
                                                        prePage: "home",
                                                        onChangeCurPage,
                                                        currentList,
                                                        setCurrentList,
                                                        getPartnerMemberList,
                                                        getPartnerMemberGrouped,
                                                        getPartnerList,
                                                        disabledids,
                                                        requiredList,
                                                        setCurrentPartnerInfo,
                                                        multiple,
                                                    }}
                                                />
                                            )}
                                            {tab.key === "externalContact" && (
                                                <ExternalContact
                                                    {...{
                                                        prePage: "home",
                                                        onChangeCurPage,
                                                        currentList,
                                                        setCurrentList,
                                                        getContactList,
                                                        disabledids,
                                                        requiredList,
                                                        multiple,
                                                    }}
                                                />
                                            )}
                                            {tab.key === "recentSession" && (
                                                <RecentSession
                                                    {...{
                                                        type,
                                                        prePage: "home",
                                                        onChangeCurPage,
                                                        onChangePrePage,
                                                        setCurrentGroupInfo,
                                                        currentList,
                                                        setCurrentList,
                                                        getRecentSessionList,
                                                        recentSessionList,
                                                        disabledids,
                                                        requiredList,
                                                        multiple,
                                                    }}
                                                />
                                            )}
                                            {tab.key === "myGroup" && (
                                                <MyGroup
                                                    {...{
                                                        prePage: "home",
                                                        type,
                                                        onChangeCurPage,
                                                        onChangePrePage,
                                                        currentList,
                                                        setCurrentList,
                                                        getMyGroupList,
                                                        myGroupList,
                                                        setCurrentGroupInfo,
                                                        disabledids,
                                                        requiredList,
                                                        multiple,
                                                    }}
                                                />
                                            )}
                                        </TabPane>
                                    ))}
                                </Tabs>
                            </div>
                        )}
                        {currentPage === "organization" && (
                            <Organization
                                {...{
                                    type,
                                    prePage: "home",
                                    onChangeCurPage,
                                    currentList,
                                    setCurrentList,
                                    getOrgList,
                                    orgList,
                                    orgBread,
                                    orgUser,
                                    disabledids,
                                    requiredList,
                                    personOrg,
                                    multiple,
                                    orginSelect,
                                }}
                            />
                        )}
                        {currentPage === "groupMember" && (
                            <GroupMember
                                {...{
                                    type,
                                    prePage,
                                    onChangeCurPage,
                                    currentList,
                                    setCurrentList,
                                    getGroupMemberList,
                                    groupMemberList,
                                    groupMemberGrouped,
                                    currentGroupInfo,
                                    disabledids,
                                    requiredList,
                                    isHideGroupMemberPageTitle,
                                    isShowGroupMemberRole,
                                    showCheckAll: showGroupMemberCheckAll,
                                    multiple,
                                }}
                            />
                        )}
                        {currentPage === "partnerMember" && (
                            <PartnerMember
                                prePage="myPartner"
                                onChangeCurPage={onChangeCurPage}
                                currentList={currentList}
                                setCurrentList={setCurrentList}
                                currentPartnerInfo={currentPartnerInfo}
                                getPartnerMemberList={getPartnerMemberList}
                                getPartnerMemberGrouped={getPartnerMemberGrouped}
                                disabledids={disabledids}
                                requiredList={requiredList}
                                showExternalContact={showExternalContact}
                                multiple={multiple}
                            />
                        )}
                        {currentPage === "batchImport" && (
                            <BatchImport
                                {...{
                                    prePage: "home",
                                    onChangeCurPage,
                                    currentList,
                                    setCurrentList,
                                    disabledids,
                                    maxNum,
                                    totalCount,
                                    batchImportApi,
                                    track,
                                    title,
                                }}
                            />
                        )}
                    </div>
                </div>
                <Main
                    {...{
                        currentList,
                        setCurrentList,
                        maxNumber,
                        onConfirm,
                        searchPlaceholder,
                        loadSearchData,
                        loadSearchDataMore,
                        searchData,
                        disabledids,
                        isLoadingSearchData,
                        requiredList,
                        pickedList,
                        searchType,
                        totalCount,
                        showSelectedNum:
                            showSelectedNum && maxNumber !== Infinity,
                        isConfirmLoading,
                        selectPanelBlur,
                        canSelectZero,
                        mainChildren,
                        justShowSelectedNoMax,
                        track,
                        title,
                    }}
                />
            </div>
        </div>
    );
};

ComplexPicker.UserPicker = UserPicker;
ComplexPicker.OrgPicker = OrgPicker;
ComplexPicker.GroupPicker = GroupPicker;
ComplexPicker.SessionPicker = SessionPicker;

ComplexPicker.defaultProps = {
    page: "home",
    type: "member",
    showGroups: false,
    showRecentSession: false,
    showOrganization: true,
    recentSessionList: [],
    myGroupList: [],
    groupMemberList: [],
    commonlyList: [],
    recentConcactsList: [],
    authority: "all",
    orgList: [],
    maxNum: 1,
    multiple: true,
    limitTips: "选择数量超限",
    disabledids: [],
    searchType: [],
    showSelectedNum: true,
};
export default ComplexPicker;
